<!-- src/views/layout/Layout.vue -->
<template>
    <el-container style="height: 100vh;">
        <!-- 侧边栏 -->
        <el-aside width="200px" style="background-color: #2c3e50; color: #fff;">
            <div class="logo">后台管理系统</div>

            <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router background-color="#2c3e50" text-color="#fff" active-text-color="#ffd04b">
                <el-submenu index="user">
                    <template slot="title">
                        <i class="el-icon-menu"></i>
                        <span slot="title">用户管理</span>
                    </template>
                    <el-menu-item index="/user/info">用户信息</el-menu-item>
                    <el-menu-item index="/user/activate">用户激活</el-menu-item>
                    <el-menu-item index="/user/orders">订单查询</el-menu-item>
                    <el-menu-item index="/user/codes">激活码查询</el-menu-item>
                </el-submenu>
                <el-submenu index="course">
                    <template slot="title">
                        <i class="el-icon-menu"></i>
                        <span slot="title">课程管理</span>
                    </template>
                    <el-menu-item index="/course/list">课程信息</el-menu-item>
                    <el-menu-item index="/course/create">课程录入</el-menu-item>
                </el-submenu>
                <el-submenu index="code">
                    <template slot="title">
                        <i class="el-icon-menu"></i>
                        <span slot="title">激活码管理</span>
                    </template>
                    <el-menu-item index="/code/list">激活码信息</el-menu-item>
                    <!-- <el-menu-item index="/code/create">激活码录入</el-menu-item> -->
                </el-submenu>
            </el-menu>
        </el-aside>

        <!-- 主体内容 -->
        <el-container>
            <!-- 顶部（可选） -->
            <!--
      <el-header style="background-color: #fff; box-shadow: 0 1px 4px rgba(0,0,0,.1); line-height: 60px;">
        Header
      </el-header>
      -->

            <!-- 内容区 -->
            <el-main style="padding: 20px; background-color: #f5f7fa;">
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
export default {
    name: 'Layout',
}
</script>

<style scoped>
.logo {
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #ecf0f1;
    background-color: #1f2d3d;
}
</style>